/**
 * 呈现面（surface）判定。
 *
 * 独立工作台与嵌入工作台共用同一份产物，但认证入口完全不同：
 * 请求拦截器在模块加载期就装好了（见 `src/request/index.ts`），
 * 路由渲染太晚，来不及决定用哪个 Token Provider。
 * 因此判定必须早于 React，且两边共用这里的常量，
 * 避免"路由改了判定没改"（docs/embedded-workbench-design.md §9.3、AR-28）。
 */
export const EMBEDDED_ROUTE_PREFIX = "/embedded";

export type Surface = "embedded" | "standalone";

export function detectSurface(pathname: string = window.location.pathname): Surface {
  return pathname === EMBEDDED_ROUTE_PREFIX || pathname.startsWith(`${EMBEDDED_ROUTE_PREFIX}/`) ? "embedded" : "standalone";
}

/** 把 `/embedded/tickets/1` 归一化为相对嵌入根的 `/tickets/1`，用于向宿主上报导航。 */
export function toEmbeddedRelativePath(pathname: string): string {
  if (pathname === EMBEDDED_ROUTE_PREFIX) {
    return "/";
  }
  return pathname.startsWith(`${EMBEDDED_ROUTE_PREFIX}/`) ? pathname.slice(EMBEDDED_ROUTE_PREFIX.length) : pathname;
}
